class ReviewsCarousel extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const initializeCarousel = () => {
			const container = this.closest('reviews-container');
			const slidesToShow = parseInt(container.getAttribute('data-slides'));
			
			$(this).slick({
				infinite: true,
				slidesToShow: slidesToShow,
				prevArrow: container.querySelector('.reviews-carousel-prev'),
				nextArrow: container.querySelector('.reviews-carousel-next'),
        dots: true,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});
		};

		initializeCarousel();
	}
}

if (!window.customElements.get("reviews-carousel")) {
	customElements.define("reviews-carousel", ReviewsCarousel);
}
